import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Autocomplete, TextField, Select, MenuItem, Button, Paper, Drawer, Snackbar } from '@mui/material';
import { DataGrid, GridRowModes } from '@mui/x-data-grid';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
import { NumericFormat } from 'react-number-format';
import { useGetSettingMutation, useGetOutletsMutation, useGetDataMutation, useSaveSettingMutation } from '../services/replenishmentSystem';
import LoadingPage from './loadingPage';
import AlertSnackbar from './alertSnackbar';

const API_URI = process.env.REACT_APP_API_URI;
// const columns = [
//   { field: 'id', headerName: 'ID', width: 70 },
//   { field: 'firstName', headerName: 'First name', width: 130 },
//   { field: 'lastName', headerName: 'Last name', width: 130 },
//   {
//     field: 'age',
//     headerName: 'Age',
//     type: 'number',
//     width: 90,
//   },
//   {
//     field: 'fullName',
//     headerName: 'Full name',
//     description: 'This column has a value getter and is not sortable.',
//     sortable: false,
//     width: 160,
//     valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//   },
// ];

export default function Replenishment() {
  const dispatch = useDispatch();
  const [getSetting, settingResult] = useGetSettingMutation();
  const [getOutlet, outletResult] = useGetOutletsMutation();
  const [getData, dataResult] = useGetDataMutation();
  const [saveSetting, saveSettingResult] = useSaveSettingMutation();
  const [outlets, setOutlets] = useState([]);
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [group, setGroup] = useState("All");
  const [outletId, setOutletId] = useState(null);
  const [topRow, setTopRow] = useState(50);
  const [rowModesModel, setRowModesModel] = useState({});
  const [selectedRow, setSelectedRow] = useState({});
  const [gridHeight, setGridHeight] = useState(300);
  const [openSetting, setOpenSetting] = useState(false);
  const [settings, setSettings] = useState({});
  const [snackContent, setSnackContent] = useState("");

  const user = JSON.parse(window.localStorage.getItem('user'));
  ModuleRegistry.registerModules([ AllCommunityModule ]);
  useEffect(() => {
    getSetting();
    getOutlet({"UserId": user.id});
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 72);
  }, []);

  useEffect(() => {
    if(outletResult && outletResult.data){
      let st = [];
      outletResult.data.map(m=>{
        st.push({value: m.value, label: m.name})
      })
      setOutlets(st);
      // setOutletId(st[0].value);
    }
  }, [outletResult]);

  useEffect(() => {
    if(dataResult.data)
    {
      const dt = JSON.parse(dataResult.data);
      setDataLoaded(dt);
      getCoumns(dt[0]);
    }
  }, [dataResult]);

  const getDataView=()=>{
    getData({"id": outletId, "TopRow": topRow, "Group": group});
  }

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleRowClick = (params) => {
    setSelectedRow(params.row);
    let data = [...dataLoaded];
    let dtl = data.find(f=>f.edit == true);
    if(dtl) dtl.edit = false;

    let dtle = data.find(f=>f.LOCATIONCODE+f.BARCODE == params.row.LOCATIONCODE+params.row.BARCODE);
    if(dtle) dtle.edit = true;
    // setDataLoaded(dataLoaded);
  };

  const onChangeData=(e, row, key)=>{
    let data = [...dataLoaded];
    let dtl = data.find(f=>f.LOCATIONCODE+f.BARCODE == row.LOCATIONCODE+row.BARCODE);
    if(dtl) dtl[key] = e.target.value;
    setDataLoaded(data);
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        cellStyle: () => ((key=="SaleQty" || key=="Stock" || key=="StockD2C" || key=="ROP" || key=="STDEVP" || key=="SuggestOrderWH" 
          || key=="SuggestTransfer" || key=="Adjust" || key=="Promotion" || key=="TotalOrder")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="SuggestOrderWH" ? "bold" : ""
        }:null),
        valueFormatter: params => (key=="ROP" || key=="STDEVP")
                      && params.data[key]?params.data[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }):params.data[key]
        // headerName: key,
        // width: 100,
        // field: key,
        // type: key=="SuggestOrderWH"?'number':'',
        // aggregable: true,
        // // editable: true,
        // // renderCell: (params) => {
        // //   // console.log(params);
        // //   return params.row.edit?<TextField size='small' value={params.value} onChange={(e)=>onChangeData(e, params.row, key)} />:params.value
        // // }
      }
    });
    setCoumns(cols);
  }

  const exportExcel=()=>{
    window.open(`${API_URI}/replenishmentsystem/exporttoexcel?id=${outletId}&toprow=${topRow}&group=${group}`, '_blank', 'noopener,noreferrer');
  }

  const handleOpenSetting=()=>{
    let sting = {...settings};
    settingResult && settingResult.data && settingResult.data.map(m=>{
      if(m.name == "AverageSaleDays")
        sting.AverageSaleDays = m.value;
      else if(m.name == "LeadtimeDelivery")
        sting.LeadtimeDelivery = m.value;
      else if(m.name == "ServiceLevel")
        sting.ServiceLevel = m.value;
    })
    setSettings(sting);
    setOpenSetting(true);
  }

  const onSaveSettings= async()=>{
    await saveSetting(settings);
    getSetting();
    setOpenSetting(false);
    setSnackContent("Saved");
  }

  const totalQuantity = useMemo(() => {
    return dataLoaded.reduce((sum, item) => {
        return {
          SaleQty: sum.SaleQty + item.SaleQty,
          Stock: sum.Stock + item.Stock,
          StockD2C: sum.StockD2C + item.StockD2C,
          SuggestOrderWH: sum.SuggestOrderWH + item.SuggestOrderWH,
          Adjust: sum.Adjust + item.Adjust,
          Promotion: sum.Promotion + item.Promotion,
          TotalOrder: sum.TotalOrder + item.TotalOrder,
        };
      }, { SaleQty: 0, Stock: 0, StockD2C: 0, SuggestOrderWH: 0, Adjust: 0, Promotion: 0, TotalOrder: 0 });
  }, [dataLoaded]);

  const pinnedBottomRowData = useMemo(() => {
    let dataTotal = {};
    Object.keys(totalQuantity).forEach(key => {
      dataTotal[`${key}`] = totalQuantity[key].toLocaleString();
    });
    return [dataTotal];
  }, [totalQuantity]);

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  return (
    <div style={{padding: '0 10px'}}>
      { (outletResult.isLoading || dataResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '20px'}}>
        <div id='divHeader'>
          <Autocomplete
            disablePortal
            size="small"
            options={outlets}
            sx={{ width: 350, float: 'left', marginRight: '10px', marginBottom: '10px' }}
            onChange={(e, item)=>setOutletId(item?item.value:0)}
            // value={outletId||null}
            renderInput={(params) => <TextField {...params} label="Outlet" />}
            loading={outletResult.isLoading}
          />
          
          <Autocomplete
            disablePortal
            size="small"
            options={[{value: 'All', label: 'All'}, {value: 'Bra', label: 'Bra'}, {value: 'Brief', label: 'Brief'}]}
            sx={{ width: 95, float: 'left', marginRight: '10px', marginBottom: '10px' }}
            onChange={(e, item)=>setGroup(item?item.value:'')}
            value={group||null}
            renderInput={(params) => <TextField {...params} label="Group" />}
            disableClearable={true}
          />

          <NumericFormat
            label="Top"
            value={50}
            customInput={TextField}
            decimalScale={0}
            // fixedDecimalScale={true}
            thousandSeparator={true}
            size="small"
            sx={{ width: 60, marginRight: '10px', marginBottom: '10px' }}
            onChange={(e)=>setTopRow(e.target.value)}
          />

          <Button variant="contained" onClick={getDataView}
            sx={{ marginRight: '10px', marginBottom: '10px' }}>View</Button>
          <Button variant="contained" onClick={exportExcel}
            sx={{ marginRight: '10px', marginBottom: '10px' }}>Export</Button>
          <Button variant="contained" onClick={()=>handleOpenSetting()}
            sx={{ marginBottom: '10px' }}>Setting</Button>
        </div>
        <Paper sx={{ height: gridHeight, width: '100%' }}>
          <AgGridReact
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            // getRowStyle={getRowStyle}
            // rowClass={rowClass}
            getRowClass={getRowClass}
            theme={theme}
          />
          {/* <DataGrid
            rows={dataLoaded}
            getRowId={(row) => row.LOCATIONCODE+row.BARCODE}
            columns={columns}
            pageSizeOptions={[50, 100]}
            // rowModesModel={rowModesModel}
            // checkboxSelection
            sx={{ border: 0 }}
            // editMode="row"
            onRowClick={handleRowClick}
            initialState={{ 
              pagination: { page: 0, pageSize: 100 },
              aggregation: {
                model: {
                  SuggestOrderWH: 'sum',
                },
              }, 
            }}
          /> */}
        </Paper>
      </div>
      <Drawer open={openSetting} onClose={()=>setOpenSetting(false)} anchor='right'>
        <div style={{ margin: '20px', marginTop: '30px' }}>
          <NumericFormat
            label="Average sale days"
            value={settings.AverageSaleDays||0}
            customInput={TextField}
            decimalScale={0}
            thousandSeparator={true}
            size="small"
            sx={{ width: 200 }}
            onChange={(e)=>setSettings({...settings, AverageSaleDays: e.target.value})}
            className="centered-input"
          />
        </div>
        <div style={{ margin: '20px', marginTop: '10px' }}>
          <NumericFormat
            label="Leadtime delivery days"
            value={settings.LeadtimeDelivery||0}
            customInput={TextField}
            decimalScale={0}
            thousandSeparator={true}
            size="small"
            sx={{ width: 200 }}
            onChange={(e)=>setSettings({...settings, LeadtimeDelivery: e.target.value})}
            className="centered-input"
          />
        </div>
        <div style={{ margin: '20px', marginTop: '10px' }}>
          <NumericFormat
            label="Service level"
            value={settings.ServiceLevel||0}
            customInput={TextField}
            decimalScale={2} 
            thousandSeparator={true}
            size="small"
            sx={{ width: 200 }}
            onChange={(e)=>setSettings({...settings, LeadtimeDelivery: e.target.value})}
            className="centered-input"
          />
        </div>
        <div style={{ margin: '20px', marginTop: '10px' }}>
          <Button variant="contained" sx={{ width: '100%' }} onClick={onSaveSettings}>Save</Button>
        </div>
      </Drawer>

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}